import GroupTypeSelect from "./group_type_select/group_type_select"
import helper from "./helper"
import('./chart_modal.scss')

export default function ChartModal(opts={}){
    BaseConstructor.call(this)
    let {options={}, datepicker_options={}, modal_options={}, forecastOptions={}, reference_values, station_ids, yaxis_options=[{station_type:'level', name: 'Nível'},{station_type:'plu', name: 'Chuva', opposite: true}]} = opts
    let elements = {}
    let context = this
    
    let modal_id,chart_id
    let chart
    let period = {start:new Date(new Date().getTime() - 60000 * 60 * 24), end:new Date()}
    let group_type = 'minute'

    this.generate = () =>{
        
    }

    this.open = _ =>{
        $("#"+modal_id).modal('show')
    }

    this.loading = _ =>{
        $("#"+chart_id).html('<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center"><div class="spinner-border" role="status"></div></div>')
    }

    this.show = _ =>{
        $("#"+modal_id).modal('show')
        
        //sempre que reabrir o modal, volta pra data das ultimas 24 horas
        // period.start=new Date(new Date().getTime() - 60000 * 60 * 24)
        // period.end=new Date()
        
        if(modal_options.period_selector){
            $('.period-selector-input').data('daterangepicker').setStartDate(period.start);
            $('.period-selector-input').data('daterangepicker').setEndDate(period.end);
        }

        this.update()
        
    }

    this.hide = _ =>{

    }

    this.updateModalTitle = (title,subtitle) =>{
        modal_options.title = title
        $('.chart-modal-component .modal-title-container').html(title)

        if(subtitle != undefined){
            modal_options.subtitle = subtitle
            $('.chart-modal-component .modal-subtitle-container').html(subtitle)
        }
    }

    this.updateStations = ids =>{
        station_ids = ids
    }

    this.updateReferenceValues = refs =>{
        reference_values = refs
    }

    this.updateYaxisOptions = options =>{
        yaxis_options = options
    }

    this.update = () =>{
        //carregando...
        // console.log(group_type);
        helper.getMeasurements(station_ids, period.start.toISOString(), period.end.toISOString(), group_type).then(data=>{
            
            if(!chart){                
                // helper.chart(chart_id)
                helper.generateChart(data.measurements, {
                    container: chart_id,
                    title: options.title,
                    yaxis_options: yaxis_options,
                    reference_values:reference_values,
                    group_type:group_type,
                    forecastOptions: forecastOptions
                })
            }
            
            
        }).always(_=>{
            //remove loading
        })
    }

    this.generateReferenceValuesPlotlines = (reference_values,valueHandle) =>{
        
        return helper.generateReferenceValues(reference_values,valueHandle)
    }

    this.setChartLimits = (chart, plots, measurements,valueHandle) =>{
        helper.setChartLimits(chart, plots, measurements,valueHandle)
    }

    this.updateDatepickerOptions = options =>{        
        datepicker_options = options
        $('.period-selector-input').data('daterangepicker').maxSpan = { days: datepicker_options.maxSpan };
    }

    this.updateDateRange = (start_date, end_date) =>{        
        period.start = new Date(start_date)
        period.end = new Date(end_date)
    }

    const addModal = () =>{
        modal_id = "modal_teste"
        chart_id = "chart_teste"
        $(document).find('body').append(
            `<div class="modal chart-modal-component" tabindex="-1" role="dialog" id=${modal_id}>`+
                '<div class="modal-dialog modal-dialog-centered modal-xxl" role="document">'+
                    '<div class="modal-content">'+
                    '<div class="modal-body">'+
                        '<div class="modal-title-wrapper">'+
                            `<div class="modal-title-container">${modal_options.title || ""}</div>`+
                            `<div class="modal-subtitle-container">${modal_options.subtitle || ""}</div>`+
                                (modal_options.period_selector ? `<div class="modal-period-selector"><input class="period-selector-input" type="text"></input></div>` : '')+
                                '<div class="modal-group-type-select-container">'+
                                    
                                '</div>'+
                            '</div>'+
                        `<div class="chart-container" id="${chart_id}"></div>`+
                    '</div>'+
                '</div>'+
            '</div>'
        )
    }

    const addGroupTypeSelect = _ =>{
        let groupTypeSelect = new GroupTypeSelect()
        $('.modal-group-type-select-container').append(groupTypeSelect.getElement())

        groupTypeSelect.on('change',data=>{
            group_type = data.new
            context.update()
        })
    }

    init()

    function init(){
        addModal()
        
        if(modal_options.period_selector){
            $('.period-selector-input').daterangepicker({
                timePicker: modal_options.period_selector.time_picker,
                startDate: period.start,
                endDate: period.end,
                showDropdowns: true,
                locale: {
                    format: 'DD/M/YYYY hh:mm A'
                },
                maxSpan:{
                    "days": datepicker_options.maxSpan || 31
                }
            }, function(start, end, label) {
                period.start = new Date(start.valueOf())
                period.end = new Date(end.valueOf())
                context.update()
            })
        }
        addGroupTypeSelect()

        var timezone = new Date().getTimezoneOffset()
        Highcharts.setOptions({
            time: {
                timezoneOffset: timezone
            },
            lang: {
                months: moment.months(),
                shortMonths: moment.monthsShort()
            }
        });
    }

    

    
}

ChartModal.prototype = Object.create(BaseConstructor.prototype)